import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';

function CloseIcon({ onClick, ...props }: IconButtonProps) {
    return (
        // Have always the hover state active
        <IconButton
            aria-label="close"
            onClick={onClick}
            {...props}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'cement.700',
                backgroundColor: 'cement.100',
                ...props.sx,
            }}>
            <CloseXIcon />
        </IconButton>
    );
}

export default CloseIcon;
